import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-test',
  standalone: false,
  templateUrl: './test.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './test.component.scss'
})
export class TestComponent {

}
